import React, { useEffect, useState } from "react";
import { FaAngleUp } from "../assets/icons/icons";

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.scrollY >= 400) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <button
            type="button"
            aria-label="Scroll to top"
            className="goTop"
            style={{ display: isVisible ? "flex" : "none" }}
            onClick={scrollToTop}
        >
            <span className="bgLinearTwo" aria-hidden="true">
                <FaAngleUp aria-hidden="true" />
            </span>
        </button>
    );
};

export default ScrollToTop;
